import { Pipe, PipeTransform } from '@angular/core';
import { ParticularOrderStatus } from 'src/generated_client';

@Pipe({
  name: 'particularOrderStatus',
})
export class ParticularOrderStatusPipe implements PipeTransform {
  transform(status: number | null | undefined): string {
    if (status === null || status === undefined) return 'Desconocido';

    switch (status) {
      case ParticularOrderStatus.NUEVO:
        return 'Nueva';
      case ParticularOrderStatus.CONFIRMADO:
        return 'Confirmada';
      case ParticularOrderStatus.ASIGNADO:
        return 'Asignada';
      case ParticularOrderStatus.ACEPTADO:
        return 'Aceptado';
      case ParticularOrderStatus.RECHAZADO:
        return 'Rechazado';
      case ParticularOrderStatus.EN_CURSO:
        return 'En curso';
      case ParticularOrderStatus.FINALIZADO:
        return 'Completada';
      case ParticularOrderStatus.CANCELADO:
        return 'Cancelada';
      default:
        return `Estado desconocido (${status})`;
    }
  }
}
